import React, { createContext, useMemo } from 'react';
import * as sharedMessages from '../translations';
export const SUPPORTED_LOCALES = ['en', 'es', 'ja'];
export const SHORT_DATE_FORMATS = ['yyyy/dd/MM', 'yyyy/MM/dd', 'MM/dd/yyyy', 'dd/MM/yyyy', 'yyyy.MM.dd'];
export const LONG_DATE_FORMATS = ['dd MMMM yyyy', 'MMMM dd yyyy', 'yyyy年MM月dd日'];
export const LONG_TO_SHORT_INPUT_MAPPING = {
    [LONG_DATE_FORMATS[0]]: 'dd MM yyyy',
    [LONG_DATE_FORMATS[1]]: 'MM dd yyyy',
    [LONG_DATE_FORMATS[2]]: 'yyyy/MM/dd',
};
export const SUPPORTED_DATE_FORMATS = [...SHORT_DATE_FORMATS, ...LONG_DATE_FORMATS];
export const SUPPORTED_TIME_FORMATS = ['HHmm', 'HH:mm', 'hh:mm a'];
export const SUPPORTED_DATE_TIME_FORMATS = SUPPORTED_DATE_FORMATS.reduce((acc, dateFormat) => {
    SUPPORTED_TIME_FORMATS.forEach((timeFormat) => {
        acc.push(`${dateFormat} ${timeFormat}`);
    });
    return acc;
}, new Array());
export const LocalizationContext = createContext({});
export const LocalizationProvider = ({ children, locale = 'en', dateFormat, timeFormat, dateTimeFormat, ...rest }) => {
    let validLocale = locale;
    if (!SUPPORTED_LOCALES.includes(locale)) {
        console.warn(`Unsupported locale passed to LocalizationProvider: ${locale}, defaulting to en.`);
        validLocale = 'en';
    }
    const localizationContextValue = useMemo(() => ({
        messages: sharedMessages,
        locale: validLocale,
        dateFormat,
        timeFormat,
        dateTimeFormat,
    }), [validLocale, dateFormat, timeFormat, dateTimeFormat]);
    return (React.createElement(LocalizationContext.Provider, { value: localizationContextValue, ...rest }, children));
};
LocalizationProvider.displayName = 'LocalizationProvider';
